module.exports = __webpack_public_path__ + "img/11.32dd98e9.png";